import {
  usersAccessRoles,
  meditationsAccessRoles,
  bannersAccessRoles,
  messageDayAccessRoles,
  videosAccessRoles,
  coursesAccessRoles,
  eventsAccessRoles,
  promoAccessRoles,
  hiddenSectionEmailsAccessRoles,
  faqAccessRoles,
  contactsAccessRoles,
  settingsAccessRoles,
  accessGrantsAccessRoles,
  reviewAccessRoles,
} from './accessRoles';

export const SECTION_ROLES: { prefix: string; roles: string[] }[] = [
  { prefix: '/users', roles: usersAccessRoles },
  { prefix: '/meditations', roles: meditationsAccessRoles },
  { prefix: '/banners', roles: bannersAccessRoles },
  { prefix: '/message-day', roles: messageDayAccessRoles },
  { prefix: '/videos', roles: videosAccessRoles },
  { prefix: '/courses', roles: coursesAccessRoles },
  { prefix: '/events', roles: eventsAccessRoles },
  { prefix: '/promo', roles: promoAccessRoles },
  { prefix: '/hidden-section-emails', roles: hiddenSectionEmailsAccessRoles },
  { prefix: '/faq', roles: faqAccessRoles },
  { prefix: '/contacts', roles: contactsAccessRoles },
  { prefix: '/push-notifications', roles: usersAccessRoles },
  { prefix: '/settings', roles: settingsAccessRoles },
  { prefix: '/access-grants', roles: accessGrantsAccessRoles },
  { prefix: '/review', roles: reviewAccessRoles },
];

export const homeFor = (role: string | undefined | null): string => {
  if (role === 'admin') {
    return '/meditations';
  }
  if (role === 'curator') {
    return '/review';
  }
  return '/profile';
};

const matchesPrefix = (pathname: string, prefix: string): boolean =>
  pathname === prefix || pathname.startsWith(`${prefix}/`);

export const resolveRoleRedirect = (
  role: string | undefined | null,
  pathname: string
): string | null => {
  const section = SECTION_ROLES.find((item) => matchesPrefix(pathname, item.prefix));

  if (!section) {
    return null;
  }

  if (role && section.roles.includes(role)) {
    return null;
  }

  return homeFor(role);
};
